import { useEffect, useState } from 'react';
import { useWindowSize } from '@utils/hooks/useWindowSize';

const TABLET_WIDTH = 768;
const LAPTOP_WIDTH = 1024;

export function useIsLaptop(): boolean {
  const [isLaptop, setIsLaptop] = useState(false);
  const size = useWindowSize();

  useEffect(
    () =>
      setIsLaptop(
        !!(
          size.width &&
          size.width > TABLET_WIDTH &&
          size.width <= LAPTOP_WIDTH
        )
      ),
    [size]
  );

  return isLaptop;
}
